import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiData } from '@wix/da-bi/pkg/events';
import Modal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import ListItemRadioButton from '@wix/da-ds/pkg/List/ListItem/dsPresets/ListItemRadioButton';
import s from './ContentFilterSettingsModal.scss';
const CONTENT_FILTER_SETTINGS = [
    'safe',
    'standard',
    'mature'
];
export const ContentFilterSettingsModal = ({ currentContentFilter = 'safe', isOver18, updateContentFilter, requestClose })=>{
    const { t } = useTranslation();
    const [contentFilter, setContentFilter] = useState(currentContentFilter);
    return /*#__PURE__*/ React.createElement(Modal, {
        contentClassName: s['modal-content'],
        heading: t('contentFilterSettingsModal.modal.title'),
        subheading: t('contentFilterSettingsModal.modal.subtitle'),
        onRequestClose: requestClose,
        isOpen: true,
        footerRight: [
            /*#__PURE__*/ React.createElement(TextButton, {
                key: "cancel",
                size: "large",
                variant: "main",
                onClick: requestClose
            }, t('contentFilterSettingsModal.modal.buttons.cancel')),
            /*#__PURE__*/ React.createElement(BrandedButton, {
                key: "save",
                size: "large",
                variant: "brand-green",
                biData: BiData({
                    evid: 307,
                    view_mode: contentFilter
                }),
                onClick: ()=>{
                    if (contentFilter !== currentContentFilter) {
                        updateContentFilter(contentFilter);
                    }
                    requestClose();
                }
            }, t('contentFilterSettingsModal.modal.buttons.save'))
        ]
    }, /*#__PURE__*/ React.createElement("div", {
        role: "radiogroup",
        "aria-label": t('contentFilterSettingsModal.modal.title')
    }, CONTENT_FILTER_SETTINGS.map((setting)=>{
        return setting === 'mature' && !isOver18 ? null : /*#__PURE__*/ React.createElement(ListItemRadioButton, {
            key: setting,
            className: s['radio-button'],
            value: setting,
            name: "content_filter",
            label: /*#__PURE__*/ React.createElement("span", {
                className: s['radio-label']
            }, t(`contentFilterSettingsModal.modal.${setting}.label`)),
            subLabel: t(`contentFilterSettingsModal.modal.${setting}.sublabel`),
            checked: contentFilter === setting,
            onChange: ()=>setContentFilter(setting)
        });
    })));
};
ContentFilterSettingsModal.displayName = 'ContentFilterSettingsModal';
export default ContentFilterSettingsModal;

//# sourceMappingURL=ContentFilterSettingsModal.js.map